module.exports = __webpack_public_path__ + "img/tpc-7.f30ce113.jpg";